import React, { ChangeEvent } from 'react'

import { DateRangeFilter, MarketSegmentFilter } from '@/components/ListFilter'
import { useTicketFiltersContext } from '@/context/filters/ticketFilters/ticketFilters'

import { OwnerFilter } from './components/OwnerFilter'
import { PriorityFilter } from './components/PriorityFilter'
import { ReasonFilter } from './components/ReasonFilter'
import { StatusFilter } from './components/StatusFilter'
import { TypeFilter } from './components/TypeFilter'

type Props = {}

export const TicketsFilterBar = ({}: Props) => {
  const { searchString, setSearchString } = useTicketFiltersContext()

  const handleSearch = (e: ChangeEvent<HTMLInputElement>) => {
    e.preventDefault()
    setSearchString(e.target.value)
  }
  return (
    <div className="flex flex-col gap-2 pb-6 md:flex-row md:flex-wrap md:items-center md:gap-3">
      <input
        autoComplete="off"
        className="w-full rounded-lg border-2 border-border-secondary p-2 focus:outline-none md:w-48 md:shrink-0"
        onChange={handleSearch}
        placeholder="Search"
        value={searchString || ''}
      />
      <div className="flex flex-row flex-wrap items-center gap-2 md:gap-3">
        <PriorityFilter />
        <TypeFilter />
        <ReasonFilter />
        <StatusFilter />
        <OwnerFilter />
        <DateRangeFilter className="whitespace-nowrap" />
        <MarketSegmentFilter className="w-auto" />
      </div>
    </div>
  )
}
